import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { Store } from '@ngrx/store';

import { ButtonComponent, Go, ImageComponent } from '@ui/legacy-lib';
import { TranslateModule } from '@ngx-translate/core';
import { MainPageNavigation } from '../../../config';

const DEFAULT_ERROR = {
  title: 'properties.not_found.error_title_l',
  description: 'properties.not_found.error_description_m',
  image: '/assets/images/Error_2.svg',
  extraText: '',
  showButton: true,
  linkLabel: 'general.back_to_app_l',
  link: MainPageNavigation.APPLICATIONS
};

@Component({
  selector: 'app-property-not-found',
  templateUrl: './property-not-found.component.html',
  styleUrls: ['./property-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImageComponent, ButtonComponent, TranslateModule]
})
export class PropertyNotFoundComponent {
  private store = inject(Store);

  public error = DEFAULT_ERROR;

  onGoBack() {
    this.store.dispatch(
      new Go({
        path: [this.error.link]
      })
    );
  }
}
